@switch (view()) {
  @case (ConcernPageView.SPLIT) {
  <app-onboarding-profile-shell [showBack]="true"
    [showFooter]="false"
    (back)="handleBack()">
    <p shellEyebrow
      class="tw-mb-2 tw-text-300 tw-font-normal tw-uppercase tw-leading-1.2 tw-text-gray-800">{{ firstName() }}</p>
    <div shellHeading
      class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
      [class.tw-text-600]="isDravidianScriptUser"
      [class.tw-text-700]="!isDravidianScriptUser"
      i18n="@@whatCanWeHelpWithV2">What can we <br/> help you with?</div>

    <div class="tw-flex tw-items-stretch tw-gap-6 tw-pt-4.5"
      [class.tw-flex-row-reverse]="showHairFirst"
      id="genderSelection">
      <app-onboarding-concern-card id="face-section"
        [concernClass]="appConfig.Shared.Regimen.Class.FACE"
        [iconUrl]="faceIconUrl()"
        (concernSelected)="updateConcern($event)">
        <ng-container i18n="@@forSkinBold"> For <b>Skin</b> Problems </ng-container>
      </app-onboarding-concern-card>
      <app-onboarding-concern-card id="hair-section"
        [concernClass]="appConfig.Shared.Regimen.Class.HAIR"
        [iconUrl]="hairIconUrl()"
        (concernSelected)="updateConcern($event)">
        <ng-container i18n="@@forHairBold"> For <b>Hair</b> Problems </ng-container>
      </app-onboarding-concern-card>
    </div>
  </app-onboarding-profile-shell>
  }
  @case (ConcernPageView.CONTROL) {
  <div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-relative">
    <div class="tw-flex-1"></div>
    <div class="tw-w-full tw-flex tw-items-end tw-justify-between tw-pl-6 tw-relative">
      <div class="tw-font-lexend tw-mb-7">
        <p class="tw-text-300 tw-uppercase tw-mb-2">{{user?.get('PatientName')?.split(" ")?.[0]}},</p>
        <p class="tw-font-bold tw-text-gray-800" [class.tw-text-600]="isDravidianScriptUser" [class.tw-text-700]="!isDravidianScriptUser" i18n='@@whatCanWeHelpWith'>What can we help you with?</p>
      </div>
      <div class="tw-min-w-[40%] tw-relative">
        <img class="tw-w-full tw-absolute -tw-bottom-5 -tw-right-4 tw-z-0" src="/assets/images/dr-charu.png" alt="Dr Charu" />
      </div>
    </div>
    <regimen-concern-selection class="tw-bg-white tw-rounded-t-5 tw-h-[65%] tw-z-10 tw-p-5 tw-pt-14"
                               [concernClass]="selectedConcernClass"
                               [gender]='user?.get("Gender")'
                               (selectConcern)="updateConcern($event)"></regimen-concern-selection>
  </div>
  }
  @default {
  <div class="tw-h-full tw-bg-teal-200"></div>
  }
}
